import request from '@/plugin/axios';

export function accountLogin(data) {
  const { username, password } = data;
  const params = {
    account: username,
    password: password,
    dataSource: username === 'superadmin' || username === 'admin' ? 'aicloud' : 'hitecloud',
    application: 'PCClient',
    platform: ''
  };

  return request({
    url: '/baseApi/user/login',
    method: 'post',
    data: params
  });
}

// 手机验证登录
export function codeLogin(data) {
  const { name, mobile, code } = data;
  const params = {
    account: mobile,
    code: code,
    dataSource: name === 'superadmin' || name === 'admin' ? 'aicloud' : 'hitecloud',
    application: 'PCClient',
    platform: ''
  };

  return request({
    url: '/baseApi/user/login',
    method: 'post',
    data: params
  });
}

// 获取用户信息
export function getUserById(userId) {
  return request({
    url: '/baseApi/user/getUserById',
    method: 'get',
    params: {
      userId
    }
  });
}

// 发送验证码
export function getMobileCode(data) {
  const { mobile, name } = data;
  const params = {
    account: name === 'superadmin' || name === 'admin' ? name : '',
    mobile,
    dataSource: name === 'superadmin' || name === 'admin' ? 'aicloud' : 'hitecloud'
  };
  return request({
    url: '/baseApi/user/getMobileCode',
    method: 'post',
    data: params
  });
}

// casid验证
export function checkCasid(data) {
  return request({
    url: '/baseApi/user/checkCas',
    method: 'post',
    data: data
  });
}

// 获取退出url
export function fetchLogoutUrl() {
  return request({
    url: '/baseApi/user/logout ',
    method: 'get'
  });
}

// 获取二维码url
export function fetchCodeUrl() {
  return request({
    url: '/baseApi/user/getQRCode ',
    method: 'get'
  });
}

// 获取扫码信息
export function fetchScanInfo(data) {
  return request({
    url: '/baseApi/user/checkQRCode',
    method: 'get',
    params: {
      code: data
    }
  });
}
